import { createContext } from 'react';
import type { BreadcrumbsProps } from '@/components/ui/breadcrumbs';

export interface PageHeaderContextType {
  header: BreadcrumbsProps | null;
  setHeader: (header: BreadcrumbsProps | null) => void;
}

export const PageHeaderContext = createContext<PageHeaderContextType | undefined>(
  undefined,
);
